import handler from 'api/handler'

const prefix = '/public/events'

const methods = {
  list: args => handler({ method: 'get', url: prefix + '/list', args }),
  sections: args => handler({ method: 'get', url: prefix + '/sections', args }),
  meta: args => handler({ method: 'get', url: prefix + '/meta', args }),
  detail: idOrSlug => handler({ method: 'get', url: `${prefix}/${idOrSlug}` }),
  book: (eventId, args) => handler({ method: 'post', url: `${prefix}/book/${eventId}`, args }),
  bookingStatus: (eventId, args) => handler({ method: 'get', url: `${prefix}/book-status/${eventId}`, args }),
  bookingStatuses: args => handler({ method: 'post', url: `${prefix}/book-statuses`, args }),
}

export default methods
